import { Typography, Button, Input } from "antd";

const { Title, Paragraph } = Typography;

// Original LockIcon component
const LockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 2.375C6.83696 2.375 6.20107 2.63839 5.73223 3.10723C5.26339 3.57607 5 4.21196 5 4.875V6.75H10V4.875C10 4.21196 9.73661 3.57607 9.26777 3.10723C8.79893 2.63839 8.16304 2.375 7.5 2.375ZM11.25 6.75V4.875C11.25 3.88044 10.8549 2.92661 10.1516 2.22335C9.44839 1.52009 8.49456 1.125 7.5 1.125C6.50544 1.125 5.55161 1.52009 4.84835 2.22335C4.14509 2.92661 3.75 3.88044 3.75 4.875V6.75H3.125C2.08947 6.75 1.25 7.58947 1.25 8.625V13C1.25 14.0355 2.08947 14.875 3.125 14.875H11.875C12.9105 14.875 13.75 14.0355 13.75 13V8.625C13.75 7.58947 12.9105 6.75 11.875 6.75H11.25ZM3.125 8C2.77982 8 2.5 8.27982 2.5 8.625V13C2.5 13.3452 2.77982 13.625 3.125 13.625H11.875C12.2202 13.625 12.5 13.3452 12.5 13V8.625C12.5 8.27982 12.2202 8 11.875 8H3.125Z"
      fill="white"
    />
  </svg>
);

// interface HeroSectionProps {
//   title: string;
//   description?: string;
//   onRequestAccess: () => void;
//   onSearch?: (value: string) => void;
// }

export default function HeroSection({
  title,
  description = "We take security, compliance, and privacy seriously. Explore our certifications, reports, and policies in one place.",
  onRequestAccess,
  onSearch,
}) {
  const handleFedRAMPMarketplace = () => {
    window.open(
      "https://marketplace.fedramp.gov/products/FR2428769635XL",
      "_blank"
    );
  };

  const handleSearch = (value) => {
    if (onSearch) {
      onSearch(value);
    }
  };

  return (
    <div style={{ marginBottom: "24px" }}>
      <Title
        level={1}
        style={{
          fontSize: "3rem",
          fontWeight: 500,
          marginBottom: "24px",
          margin: "0 0 24px 0",
        }}
      >
        {title}
      </Title>
      <Paragraph
        style={{
          fontSize: "20px",
          color: "#666",
          marginBottom: "32px",
          maxWidth: "600px",
        }}
      >
        {description}
      </Paragraph>

      {/* Action Buttons - Responsive */}
      <div
        className="hero-action-buttons"
        style={{ marginBottom: "48px", display: "flex", gap: "16px" }}
      >
        <Button
          type="primary"
          size="large"
          onClick={onRequestAccess}
          className="hero-action-btn"
          style={{
            backgroundColor: "#000",
            borderColor: "#000",
            borderRadius: "8px",
            height: "48px",
            padding: "0 24px",
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: "8px",
            width: "100%",
            maxWidth: "200px",
          }}
        >
          Request Access
          <LockIcon />
        </Button>
        {/* <Button
          size="large"
          onClick={handleFedRAMPMarketplace}
          className="hero-action-btn"
          style={{
            borderRadius: "8px",
            height: "48px",
            padding: "0 24px",
            fontWeight: 500,
            width: "100%",
            maxWidth: "200px",
          }}
        >
          FedRAMP Marketplace
        </Button> */}
      </div>

      {/* Responsive CSS for stacking buttons */}
      <style>{`
        @media (max-width: 450px) {
          .hero-action-buttons {
            flex-direction: column !important;
            gap: 12px !important;
            align-items: stretch !important;
          }
          .hero-action-btn {
            width: 100% !important;
            max-width: none !important;
          }
        }
      `}</style>

      {/* Search Bar */}
      <Input
        placeholder="Search ..."
        suffix={
          <span
            style={{
              padding: "4px 8px",
              border: "1px solid #d9d9d9",
              borderRadius: "4px",
              fontSize: "16px",
              color: "#999",
            }}
          >
            ⌘K
          </span>
        }
        size="large"
        onChange={(e) => {
          if (onSearch) {
            onSearch(e.target.value);
          }
        }}
        onPressEnter={(e) => handleSearch(e.target.value)}
        style={{
          maxWidth: "100%",
          borderRadius: "8px",
          height: "50px",
        }}
      />
    </div>
  );
}
